const route = {
	path: '/todos',
	name: 'page-todo',
	meta: {
		title: 'Tareas',
	},
	component: () => import('@/pages/todos/page-todo'),
	children: [
		{
			path: 'new',
			name: 'page-todo-new',
			meta: {
				title: 'Nuevo Tarea',
			},
			component: () => import('@/pages/todos/page-todo-new'),
		},
		{
			path: ':id/edit',
			name: 'page-todo-edit',
			meta: {
				title: 'Editar Tarea',
			},
			component: () => import('@/pages/todos/page-todo-new'),
			props: true,
		},
	],
};

export default route;



// WEBPACK FOOTER //
// ./src/router/todos.js